import React, { useState, useEffect } from "react"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import Block from "@bappweb/block"
import Link from "@bappweb/link"

type propType = {
  faqText: any[]
}

const SssList = ({faqText}:propType) => {
  return (
    <Page padding={false}>
      <Panel hasFooter={false} noHeader className="accordion-container">
        <Element type="h2">Ticari Kredi Kartı Başvurusu Hakkında Bilmeniz Gerekenler</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item: any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              ><Block dangerouslySetInnerHTML={{ __html: item?.data }} /></List.Item>
            )
          })}
        </List>
      </Panel>
    </Page>
  )
}

export default SssList
